<template>
	<el-dialog v-dialogDrag class="setting" title="设置" :visible.sync="visible" width="420px" :before-close="onClose">
		<el-form :model="userInfo" label-width="80px" :rules="rules" ref="settingForm" size="small">
			<el-form-item label="头像" style="margin-bottom: 0 !important;">
				<file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize"
					:isPermanent="true" @success="onUploadSuccess"
					:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
					<img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</file-upload>
			</el-form-item>
			<el-form-item label="用户名">
				<el-input disabled v-model="userInfo.userName" autocomplete="off" size="small"></el-input>
			</el-form-item>
			<el-form-item prop="nickName" label="昵称">
				<input
					v-model="userInfo.nickName"
					autocomplete="off"
					maxlength="20"
					class="native-nickname-input"
					style="width: 270px; height: 32px; padding: 0 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: content-box;"
				/>
			</el-form-item>
			<el-form-item label="性别">
				<el-radio-group v-model="userInfo.sex">
					<el-radio :label="0">男</el-radio>
					<el-radio :label="1">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="个性签名">
				<el-input type="textarea" v-model="userInfo.signature" :rows="3" maxlength="64"></el-input>
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="onClose()">取 消</el-button>
			<el-button type="primary" style="background-color: #027aff;border: none;" @click="onSubmit()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";

export default {
	name: "setting",
	components: {
		FileUpload
	},
	data() {
		return {
			userInfo: {},
			maxSize: 5 * 1024 * 1024,
			action: "/image/upload",
			rules: {
				nickName: [{
					required: true,
					message: '请输入昵称',
					trigger: 'blur'
				}]
			}
		}
	},
	methods: {

		onClose() {
			this.$emit("close");
		},
		onSubmit() {
			this.$refs['settingForm'].validate((valid) => {
				if (!valid) {
					return false;
				}
				this.$http({
					url: "/user/update",
					method: "put",
					data: this.userInfo
				}).then(() => {
					this.$store.commit("setUserInfo", this.userInfo);
					this.$emit("close");
					this.$message.success("修改成功");
				})
			});
		},
		onUploadSuccess(data, file) {
			this.userInfo.headImage = data.originUrl;
			this.userInfo.headImageThumb = data.thumbUrl;
		}
	},
	props: {
		visible: {
			type: Boolean
		}
	},
	computed: {
		imageAction() {
			return `/image/upload`;
		}
	},
	watch: {
		visible: function(newData, oldData) {
			// 深拷贝
			let mine = this.$store.state.userStore.userInfo;
			this.userInfo = JSON.parse(JSON.stringify(mine));
		}
	}
}
</script>

<style lang="scss" scoped>
.setting {
	.el-form {
		padding: 10px 0 0 10px;
	}

	.avatar-uploader {
		--width: 112px;
		margin-bottom: 15px;
		.avatar-uploader-icon{
			border: 1px solid #DCDFE6;
		}
		.el-upload {
			border: 1px dashed #d9d9d9 !important;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.el-upload:hover {
			border-color: #409EFF;
		}

		.avatar-uploader-icon {
			font-size: 24px;
			color: #8c939d;
			width: var(--width);
			height: var(--width);
			line-height: var(--width);
			text-align: center;
		}

		.avatar {
			width: var(--width);
			height: var(--width);
			display: block;
		}
	}
}
</style>

<style scoped lang="scss">
::v-deep .el-dialog {
  top: 50% !important;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  display: block;
  border-radius: 4px !important;
}

// 设置单选按钮边框颜色
::v-deep .el-radio__inner {
  border-color: #027aff !important;
}
::v-deep .el-radio__inner:hover {
  border-color: #057aff !important;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #057aff !important;
  background: #057aff !important;
}
::v-deep .el-radio__input.is-focus .el-radio__inner {
  border-color: #057aff !important;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #057aff !important;
}

// 设置个性签名输入框边框颜色
::v-deep .el-textarea__inner {
  border-color: #dcdfe6 !important;
}
::v-deep .el-textarea__inner:focus {
  border-color: #057aff !important;
}

// 提高优先级，确保昵称输入框聚焦时只保留蓝色边框，无任何描边
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:focus,
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:active {
  border: none !important;
  border-color: transparent !important;
  border-width: 0 !important;
  border-style: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
}
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:focus:after,
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:active:after,
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:focus:before,
::v-deep .setting .el-form-item[prop="nickName"] .el-input__inner:active:before {
  border: none !important;
  border-color: transparent !important;
  border-width: 0 !important;
  border-style: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  content: none !important;
}

// 终极覆盖 Element UI 输入框聚焦样式为 #027aff
::v-deep .el-form-item[prop="nickName"] .el-input__inner:focus,
::v-deep .el-form-item[prop="nickName"] .el-input__inner:active {
  border-color: #027aff !important;
  outline: 2px solid #027aff !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 2px #027aff !important;
  transition: none !important;
}

// 将昵称输入框替换为原生 input
.native-nickname-input:focus {
  border-color: #027aff !important;
  outline: none !important;
  box-shadow: none !important;
  transition: border-color 0s linear !important;
}

// 设置取消按钮样式
::v-deep .dialog-footer .el-button:not(.el-button--primary) {
  color: #027aff !important;
  background-color: #027aff10 !important;
  border-color: #027aff80 !important;
}

// 设置 el-dialog 右上角关闭按钮 hover 后颜色为 #057aff
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #057aff !important;
}
</style>